import { render, staticRenderFns } from "./MarkAsHiddenBtn.vue?vue&type=template&id=42a0430a&scoped=true&"
import script from "./MarkAsHiddenBtn.vue?vue&type=script&lang=js&"
export * from "./MarkAsHiddenBtn.vue?vue&type=script&lang=js&"
import style0 from "./MarkAsHiddenBtn.vue?vue&type=style&index=0&id=42a0430a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a0430a",
  null
  
)

export default component.exports